import React from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, ThemeProvider, createTheme  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import ActionDetailPopper from '../../containers/ActionDetailPopper';
import { useSelector } from 'react-redux';
import { LeadershipRole } from '../../api/typesDc';
import { useTranslation } from 'react-i18next';
import { QualificationList } from '../QualificationList';
import MultiSelectPrimary from '../MultiSelectPrimary';
import StaffMemberRolesAutocomplete from '../StaffMemberRolesAutocomplete';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const StaffRoleTable = () => {

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');

  const [openActionDetail, setOpenActionDetail] = React.useState(false);
  const staffList = useSelector((state:any) => state.dataCaptures.staffDetails);
  const isAdmin = useSelector((state:any) => state.common.isAdmin);
  const [t] = useTranslation();
  let types:any = [];

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const staffRoles:any = [
      {role: t('DC_5_ROLE_A'), staffMembers: [], roleQualifications: LeadershipRole.LR_HEAD_OF_DEV_DEP },
      {role: t('DC_5_ROLE_B'), staffMembers: [], roleQualifications: LeadershipRole.LR_U18_COACH},
      {role: t('DC_5_ROLE_B'), staffMembers: [], roleQualifications: LeadershipRole.LR_U15_COACH},
      {role: t('DC_5_ROLE_D'), staffMembers: [], roleQualifications: LeadershipRole.LR_U12_COACH},
      {role: t('DC_5_ROLE_E'), staffMembers: [], roleQualifications: LeadershipRole.LR_ACADEMY_TC}
  ];

  const visibleRows = React.useMemo(
    () =>
      staffRoles?.length > 0 &&
      stableSort(staffRoles, getComparator(order, orderBy)),
    [order, orderBy, staffRoles],
  );

  const head = [
    {
        key: '', displayName: t('ROLE'),
    },
    {
        key: '', displayName: t('DC_5_STAFF_MEMBERS'),
    },
    {
        key: '', displayName: '',
    }
  ]
  

  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative' }}>
              <ActionDetailPopper isOpen={openActionDetail} handleIsOpen={() => {setOpenActionDetail(false)}} />
              <TableContainer>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    bg={'#FAFAFA'}
                    />
                    <TableBody>
                    {
                        visibleRows && visibleRows?.length &&
                        visibleRows?.map((d: any, i: number) => (
                        <TableRow
                        sx={{ cursor: isAdmin ? 'not-allowed' : 'pointer' }}
                        key={`accountingpl-table-row-${i}`}
                        >
                            <TableCell className='fs12'>
                            {d.role}
                            </TableCell>
                            <TableCell className='fs12' width={'300px'}>
                              <StaffMemberRolesAutocomplete role={d.roleQualifications} isReadOnly={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <QualificationList role={d.roleQualifications}/>
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default StaffRoleTable;